
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form18";
const form18State = namespace("Form18");

import Form18ProcessHeader from "@/components/process/Form18/components/Form18ProcessHeader.vue";
import Form18 from "@/components/process/Form18/components/pdf/Form18.vue"

import { form18StatusInfoType } from '@/types/Information/Form18';

@Component({
    components:{
        Form18ProcessHeader,
        Form18
    }
})
export default class PreviewForm18 extends Vue {

    @form18State.State
    public currentNoticeOfRepChangeAddressId: string;

    stepsCompleted = {} as form18StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form18"}); 
    }
}
